import { render } from "./Pagination.vue?vue&type=template&id=8f5840c6"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f5840c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f5840c6', __exports__)) {
    api.reload('8f5840c6', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=8f5840c6", () => {
    api.rerender('8f5840c6', render)
  })

}


export default __exports__